/**
 * ADR-0024 D12 - todo texto de interface vive aqui desde a primeira tela.
 * Nenhum texto e escrito diretamente no componente.
 *
 * Um unico idioma e publicado no Incremento 1: pt-BR. A estrutura ja esta
 * pronta para um segundo idioma sem varredura de telas.
 */
export const ptBR = {
  app: {
    name: 'STRONGERH ONE',
    tagline: 'Plataforma de gestão de pessoas',
  },
  home: {
    greeting: 'Olá',
    subtitle: 'Escolha um módulo no menu ao lado.',
    noModules:
      'Seu usuário ainda não tem acesso a nenhum módulo. Fale com o administrador da sua empresa.',
  },
  shell: {
    navLabel: 'Menu principal',
    home: 'Início',
    units: 'Unidades',
    jobs: 'Cargos',
    assistant: 'Pergunte ao sistema',
    company: 'Empresa',
    // s69 / 2x: usuarios da empresa em que se esta trabalhando
    users: 'Usuários',
    aiDescription: 'Descrição com IA',
    signOut: 'Sair',
    signature: 'uma solução',
    clientLogoAlt: 'Logo da empresa',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    workTenantLabel: 'Empresa',
    workTenantOwn: 'Minha empresa',
    workTenantBanner: 'Trabalhando em:',
    workTenantBack: 'Voltar à minha empresa',
    // s67 / 2i (V1, Marcelo 25/10/2026 14:46): com a IA LIGADA o item do menu e "Pergunte à VIGA"; sem IA, o de sempre
    assistantAi: 'Pergunte à VIGA',
    // s67 / 2i (R2, padrao Rippling): busca no topo
    searchLabel: 'Buscar',
    searchPlaceholder: 'Buscar cargo, pessoa ou área…',
    searchPeople: 'Pessoas',
    searchJobs: 'Cargos',
    searchUnits: 'Áreas',
    searchAsk: 'Perguntar à VIGA:',
    searchEmpty: 'Nada encontrado',
    // s67 / 2i (V3, padrao Attio): a VIGA em toda tela, num painel lateral
    dockOpenAi: 'Abrir a VIGA',
    dockOpen: 'Abrir o assistente',
    dockClose: 'Fechar o painel',
  },
  // s65 / PE -- tela "Empresa" (perfil da empresa)
  companyProfile: {
    title: 'Perfil da empresa',
    back: 'Voltar',
    introEdit: 'O que a empresa faz e como funciona. A VIGA e as sugestões de descrição usam este perfil.',
    introRead: 'O que a empresa faz e como funciona. Quem preenche é o consultor da Gente; fale com ele para mudar algo.',
    basics: 'O básico',
    whatItDoes: 'O que a empresa faz',
    howItWorks: 'Como a empresa funciona',
    setor: 'Setor',
    ramo: 'Ramo',
    uf: 'UF',
    cidade: 'Cidade',
    porte: 'Porte',
    atividades: 'Atividades principais',
    produtos: 'Produtos e serviços',
    processos: 'Processos-chave',
    unidades: 'Unidades / locais',
    turnos: 'Turnos',
    mercado: 'Mercado / clientes',
    certificacoes: 'Certificações',
    newProduto: 'Novo produto ou serviço',
    newProcesso: 'Novo processo',
    newCertificacao: 'Nova certificação',
    enterToAdd: 'Digite e tecle Enter para incluir.',
    upTo: 'até',
    none: '—',
    warning:
      'Não escreva o nome da empresa, de clientes ou de pessoas. Antes de ir à IA, o sistema troca o nome e o domínio da empresa por um código.',
    filled: 'Preenchidos',
    of: 'de',
    save: 'Salvar perfil',
    saved: 'Perfil salvo.',
    // s67 / PE2 (Marcelo 25/10/2026 11:55, "APROVADO PE2 ; F1-F4 sim")
    research: 'Pesquisa do perfil',
    researchIntro:
      'Gere o texto, cole numa ferramenta de pesquisa fora do sistema e escreva lá o nome e o CNPJ da empresa. O texto não leva o nome da empresa. Depois cole aqui a resposta.',
    researchGenerate: 'Gerar texto de pesquisa',
    researchText: 'Texto de pesquisa',
    researchCopy: 'Copiar',
    researchCopied: 'Copiado.',
    researchPaste: 'Cole aqui o resultado',
    researchRead: 'Ler resultado',
    researchDraft: 'campo(s) lido(s). É um rascunho: confira e clique em "Salvar perfil".',
    researchUnknown: 'Não entendi estas linhas:',
    locais: 'Locais',
    localNome: 'Nome do local',
    localCidade: 'Cidade do local',
    localUf: 'UF do local',
    localTipo: 'Tipo do local',
    localAdd: 'Incluir local',
    oldText: 'Texto antigo (vale até haver locais):',
    sources: 'Fontes',
    removeSource: 'Tirar a fonte de',
    confirmTitle: 'Confirmação do cliente',
    confirmNone: 'Ainda não confirmado pelo cliente.',
    confirmedBy: 'Confirmado por',
    confirmedAt: 'em',
    confirmButton: 'Confirmar perfil',
    confirmHelp:
      'O administrador ou o RH da empresa confirma que o perfil está certo. Se o consultor mudar o perfil, a confirmação volta a ficar pendente.',
    confirmUnsaved: 'Há mudanças não salvas: salve antes de confirmar.',
  },
  units: {
    title: 'Unidades',
    subtitle: 'Estrutura organizacional da sua empresa.',
    newUnit: 'Nova unidade',
    edit: 'Editar',
    save: 'Salvar',
    cancel: 'Cancelar',
    noParent: 'Sem unidade-mãe (topo)',
    codeHelp: 'Gerado a partir do nome. Não muda depois de criado.',
    codeInvalid: 'Use só letras minúsculas, números e hífen (2 a 64), sem hífen nas pontas.',
    errDuplicate: 'Já existe uma unidade com esse código. Mude o código e salve de novo.',
    errCycle: 'Essa mudança criaria um ciclo: a unidade ficaria dentro dela mesma. Escolha outra unidade-mãe.',
    errParent: 'A unidade-mãe escolhida não existe mais. Recarregue a tela e escolha de novo.',
    errGeneric: 'Não foi possível salvar. Tente de novo; se repetir, fale com o suporte.',
    empty: 'Nenhuma unidade cadastrada ainda.',
    tooMany: 'A estrutura tem mais unidades do que esta tela mostra. Fale com o suporte.',
    invalidRows: (n: number) =>
      n === 1
        ? '1 unidade tem dado inválido e não aparece nesta estrutura. Fale com o suporte.'
        : `${n} unidades têm dado inválido e não aparecem nesta estrutura. Fale com o suporte.`,
    expand: 'Abrir',
    collapse: 'Fechar',
    // s61 / E2: organograma em caixas (P1-P4 da s57).
    viewLabel: 'Modo de ver as unidades',
    viewList: 'Lista',
    viewChart: 'Organograma',
    viewAreas: 'Áreas',
    orgChart: {
      title: 'Organograma',
      payrollDate: (d: string) => `Folha de ${d}`,
      payrollUnknown: 'Data da folha não informada',
      totalPeople: (n: number) => (n === 1 ? '1 pessoa ativa' : `${n} pessoas ativas`),
      people: (n: number) => (n === 1 ? '1 pessoa' : `${n} pessoas`),
      noJobs: 'Nenhum cargo nesta área',
      withoutArea: 'Cargos sem área',
      withoutAreaHint: 'A descrição destes cargos ainda não diz a área, ou a área foi desativada.',
      peopleWithoutJob: (n: number) =>
        n === 1
          ? '1 pessoa ativa está sem cargo: conta na área onde está lotada, mas não aparece em nenhum cargo.'
          : `${n} pessoas ativas estão sem cargo: contam na área onde estão lotadas, mas não aparecem em nenhum cargo.`,
      namesOnlyHr: 'Os nomes das pessoas ficam visíveis só para o RH e os administradores.',
      seeNames: (cargo: string, n: number) => `${cargo}, ${n === 1 ? '1 pessoa' : `${n} pessoas`}: ver nomes`,
      namesEmpty: 'Nenhuma pessoa ativa neste cargo.',
      close: 'Fechar',
      // s62 / fatia s60c
      vacant: 'vago',
      ofTotal: (n: number) => `de ${n} no total`,
      reportsTo: (cargo: string) => `responde a ${cargo}`,
      pendingArea: (area: string) => `rascunho: vai para ${area}`,
      staffedHere: 'Lotados aqui, de outras áreas',
      zoomGroup: 'Zoom do organograma',
      openArea: (area: string, n: number) => `${area}, ${n === 1 ? '1 pessoa' : `${n} pessoas`}: ver os cargos`,
      zoomOut: 'Diminuir',
      zoomIn: 'Aumentar',
      zoomFit: 'Ajustar à tela',
      dragHint: 'Arraste o fundo para mover.',
      // s62 / C3a: organograma de CARGOS em bandas (lista fixa da metodologia Gente; a letra do grau so com o modulo de salario)
      bands: {
        direcao: 'DIREÇÃO',
        gerencia_executiva: 'GERÊNCIA EXECUTIVA',
        gerencia: 'GERÊNCIA / ESPECIALISTAS SÊNIOR',
        media_lideranca: 'MÉDIA LIDERANÇA',
        lideranca_operacional: 'LIDERANÇA OPERACIONAL',
        operacional: 'OPERACIONAL',
      } as Record<string, string>,
      bandsHint: 'Cada cargo na faixa da sua função, ligado ao cargo a que responde. Cargo sem função aparece na faixa sugerida pelo título (borda tracejada) até a função ser escolhida na ficha do cargo.',
      suggestedBand: 'faixa sugerida',
      advisoryColumn: 'ASSESSORIAS',
      advisoryToggle: 'Área de assessoria',
      advisoryHint: 'Áreas de assessoria (ex.: Jurídico, Controladoria) ficam numa coluna ao lado do mapa.',
      advisoryError: 'Não foi possível gravar. Tente de novo.',
    },
    panelClose: 'Fechar detalhes',
    fieldCode: 'Código',
    fieldName: 'Nome',
    fieldShortName: 'Nome curto',
    fieldType: 'Tipo',
    fieldStatus: 'Situação',
    fieldParent: 'Unidade-mãe',
    none: '—',
    types: {
      directorate: 'Diretoria',
      department: 'Departamento',
      area: 'Área',
      team: 'Equipe',
      other: 'Outro',
    },
    statuses: {
      active: 'Ativa',
      inactive: 'Inativa',
      archived: 'Arquivada',
    },
  },
  // s69 / 2x (Marcelo 29/10/2026 17:25-17:28): tela de Usuarios
  users: {
    title: 'Usuários',
    ofCompany: (e: string) => `Quem entra no sistema pela empresa ${e}.`,
    newUser: 'Novo usuário',
    newUserIn: (e: string) => `Novo usuário em ${e}`,
    empty: 'Ainda não há usuários nesta empresa.',
    colName: 'Usuário',
    colEmail: 'E-mail',
    colRoles: 'Papéis',
    colStatus: 'Situação',
    noRole: 'Sem papel',
    active: 'Ativo',
    inactive: 'Inativo',
    firstAccessPending: '1º acesso pendente',
    deactivate: 'Desativar',
    reactivate: 'Reativar',
    confirmDeactivate: (u: string, e: string) => `Desativar ${u} em ${e}? A pessoa deixa de entrar; nada é apagado.`,
    confirmReactivate: (u: string, e: string) => `Reativar ${u} em ${e}? A pessoa volta a entrar.`,
    cancel: 'Cancelar',
    next: 'Continuar',
    back: 'Voltar',
    create: 'Criar usuário',
    confirmTitle: 'Confirme antes de criar',
    confirmCreate: (u: string, e: string, p: string) =>
      `Criar ${u} na empresa ${e}, com o papel ${p}? A pessoa entra com o e-mail e a senha inicial e troca a senha no 1º acesso; o código de verificação chega no e-mail dela.`,
    fieldName: 'Nome de usuário',
    fieldNameHint: 'É o nome que aparece no "Olá" (ex.: maria.souza vira "Maria Souza"). Para entrar, a pessoa usa o e-mail.',
    fieldEmail: 'E-mail corporativo',
    fieldEmailHint: (d: string) => `Tem de ser do domínio da empresa (${d}): é por ele que o sistema sabe a empresa de quem entra.`,
    fieldPassword: 'Senha inicial (12 caracteres ou mais)',
    fieldPasswordHint: 'Entregue à pessoa por outro canal (nunca no mesmo e-mail). Ela troca no 1º acesso.',
    fieldPassword2: 'Repita a senha inicial',
    fieldRoles: 'Papéis',
    errName: 'Escreva o nome de usuário.',
    errEmail: 'Escreva um e-mail válido.',
    errDomain: (d: string) => `O e-mail tem de ser do domínio da empresa (${d}). Com outro domínio a pessoa não consegue entrar.`,
    errExists: 'Já existe um usuário com esse nome ou e-mail nesta empresa.',
    errPasswordShort: 'A senha inicial precisa ter 12 caracteres ou mais.',
    errPasswordMismatch: 'As duas senhas não são iguais.',
    errPassword: 'A senha inicial não pode ser igual ao nome de usuário nem ao e-mail, e precisa ter 12 caracteres ou mais.',
    errRole: 'Escolha pelo menos um papel.',
    errForbidden: 'Seu acesso não permite criar usuário nesta empresa.',
    selfDenied: 'Você não pode desativar o seu próprio usuário.',
    genericError: 'Não foi possível concluir. Tente de novo.',
  },
  jobs: {
    title: 'Cargos',
    subtitle: 'Cargos da sua empresa. Salários ficam em outro módulo.',
    empty: 'Nenhum cargo cadastrado ainda.',
    noMatch: 'Nenhum cargo com esses filtros.',
    clearFilters: 'Limpar filtros',
    tooMany: 'A empresa tem mais cargos do que esta tela mostra. Fale com o suporte.',
    searchLabel: 'Buscar cargo',
    searchPlaceholder: 'Nome ou CBO',
    filterLevel: 'Nível',
    filterStatus: 'Situação',
    colCode: 'Código',
    colName: 'Nome',
    colLevel: 'Nível',
    colCareer: 'Carreira',
    colCbo: 'CBO',
    colStatus: 'Situação',
    // s61 / E1: estado da descricao do cargo (sem o texto).
    colDescription: 'Descrição',
    colFunction: 'Função',
    bandsLink: 'Faixas e funções',
    // s69 / 2r: criar cargo pela tela
    newJob: 'Novo cargo',
    newJobTitle: 'Novo cargo',
    newJobName: 'Nome do cargo',
    newJobCbo: 'CBO (opcional)',
    newJobHint: 'Depois de criar, a ficha do cargo abre: ali você escreve a descrição (área, subordinação, entregas) e escolhe a função. O CBO também pode ser sugerido pela VIGA na ficha.',
    newJobCreate: 'Criar cargo',
    newJobCancel: 'Cancelar',
    newJobNameInvalid: 'Escreva o nome do cargo (pelo menos 2 letras ou números).',
    newJobCboInvalid: 'O CBO tem 6 dígitos (ex.: 4110-10). Deixe vazio se ainda não souber.',
    newJobDuplicate: 'Já existe um cargo com este nome nesta empresa.',
    newJobError: 'Não foi possível criar o cargo. Tente de novo.',
    filterDescription: 'Descrição',
    descPublished: (v: number) => `Publicada v${v}`,
    descDraftOnly: 'Rascunho',
    descDraftOpen: 'rascunho aberto',
    descNone: 'Sem descrição',
    descriptionFilters: {
      published: 'Publicada',
      draft: 'Com rascunho',
      none: 'Sem descrição',
    },
    none: '—',
    panelClose: 'Fechar detalhes',
    openRecord: 'Abrir ficha do cargo',
    recordTitle: 'Ficha do cargo',
    rowsOf: (from: number, to: number, count: number) => `${from}–${to} de ${count}`,
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    levels: {
      junior: 'Júnior',
      pleno: 'Pleno',
      senior: 'Sênior',
      specialist: 'Especialista',
    },
    statuses: {
      active: 'Ativo',
      inactive: 'Inativo',
      archived: 'Arquivado',
    },
  },
  // Tela 5 (sessao 38) - ficha do cargo no layout do PES.001, so leitura.
  jobRecord: {
    back: 'Voltar para Cargos',
    notFound: 'Cargo não encontrado. Ele pode ter sido removido ou não pertencer à sua empresa.',
    fieldCode: 'Código',
    fieldCbo: 'CBO',
    // s69 / 2s: situacao do cargo
    fieldStatus: 'Situação',
    statusSaveError: 'Não foi possível mudar a situação. Tente de novo.',
    // s69 / 2m (C2): CBO digitado na ficha
    cboEdit: 'Editar o CBO',
    cboSave: 'Salvar',
    cboCancel: 'Cancelar',
    cboHint: '6 dígitos, no formato 0000-00. Vazio limpa.',
    cboInvalid: 'O CBO tem 6 dígitos (ex.: 4110-10).',
    cboSaveError: 'Não foi possível salvar o CBO. Tente de novo.',
    // s69 / 2o (V1): sugestao pela tabela oficial
    cboSuggest: 'Sugerir com a VIGA',
    // s69 / 2q: sem IA o texto diz o que e -- busca simples, nao a escolha da VIGA
    cboSuggestHint: 'Busca simples na tabela oficial da CBO (sem IA), pelo nome e pelas atividades do cargo. Confira com cuidado antes de salvar.',
    // s69 / 2p (ADR-0035): a VIGA escolhe entre as ocupacoes oficiais; selo "CBO a revisar"
    cboSuggestHintViga: 'A VIGA escolheu na tabela oficial da CBO, pelo que o cargo faz. Confira antes de salvar.',
    cboSuggestDegraded: 'A VIGA não respondeu agora; estas sugestões vêm só da tabela oficial.',
    cboViaAtividades: 'pelas atividades do cargo',
    cboReview: 'CBO a revisar',
    cboReviewHint: 'O CBO gravado não aparece entre as ocupações oficiais mais próximas do nome e das atividades deste cargo. Confira; nada foi trocado.',
    cboReviewMissing: 'O CBO gravado não existe na tabela oficial da CBO 2002. Confira; nada foi trocado.',
    cboSuggestNone: 'A VIGA não achou na tabela oficial uma ocupação parecida com o nome deste cargo. Digite o código.',
    cboSuggestUnavailable: 'A tabela oficial da CBO ainda não está instalada.',
    cboSuggestError: 'Não foi possível buscar as sugestões. Tente de novo.',
    cboVia: (texto: string) => `pelo nome "${texto}"`,
    fieldFuncao: 'Função',
    fieldArea: 'Área',
    fieldReportsTo: 'Subordinação',
    notInformed: 'Não informado',
    sectionPapel: 'Papel da função',
    sectionEntregas: 'Entregas e atividades',
    sectionEntregasHint: 'Cada resultado esperado, com as atividades que o geram.',
    noActivities: 'Nenhuma atividade ligada a esta entrega.',
    sectionTransversais: 'Atividades transversais',
    sectionCompetencias: 'Competências — conhecimentos',
    sectionFormacao: 'Formação',
    sectionConhecimentos: 'Hard skills',
    sectionTreinamentos: 'Treinamentos',
    colNecessario: 'Necessário',
    colDesejavel: 'Desejável',
    sectionExperiencia: 'Experiência',
    sectionSoftSkills: 'Soft skills',
    // Q6/D3: texto FIXO do modelo PES.001 (nao e dado do cargo). Unico texto fixo na tela.
    softSkillsNotice:
      'O detalhamento das habilidades e atitudes tem função apenas orientativa para o processo de gestão e de recrutamento e seleção. São direcionais para o desenvolvimento no desempenho da função; portanto, não devem ser considerados pré-requisitos ou requisitos necessários.',
    legacyBadge: 'Descrição antiga',
    legacyHint: 'Este cargo ainda não tem descrição publicada no modelo novo. Abaixo, o texto que estava cadastrado.',
    draftInProgress: (n: number) => `Há um rascunho em elaboração (versão ${n}).`,
    // s55 (R1): a ficha mostra o RASCUNHO a quem edita, com selo; quem so le continua vendo a versao oficial.
    draftBadge: (n: number) => `Rascunho · versão ${n} · ainda não publicado`,
    draftHint: 'Você vê o rascunho porque pode editar. Quem só consulta continua vendo a descrição antiga até a publicação.',
    versionLine: (n: number, data: string) => `Versão ${n} · publicada em ${data}`,
    previousVersions: (q: number) => (q === 1 ? '1 versão anterior' : `${q} versões anteriores`),
    hidePrevious: 'Ocultar versões anteriores',
    // Tela 6 (s43): so aparece para quem tem description.write.
    editDescription: 'Editar descrição',
  },
  // Tela 6 (sessao 43, F1) - editor do rascunho da descricao do cargo (parte manual).
  descriptionEditor: {
    // s62 / C3b-2 (F3): a funcao e do cargo
    functionFromJob: 'Função do cargo (muda na ficha do cargo)',
    functionChooseInJob: 'Escolha a função na ficha do cargo',
    back: 'Voltar para a ficha do cargo',
    noPermission: 'Você não tem permissão para editar a descrição deste cargo.',
    draftLabel: (n: number) => `Rascunho · versão ${n}`,
    noDraftHint: 'Este cargo não tem rascunho em elaboração.',
    startFromPublished: (n: number) => `Editar a partir da versão publicada ${n}`,
    startEmpty: 'Começar a descrição',
    headerTitle: 'Cabeçalho',
    none: '(nenhuma)',
    saveHeader: 'Salvar cabeçalho',
    headerFieldError: {
      area: 'Esta área não está disponível. Escolha outra unidade.',
      subordinacao: 'Este cargo não está disponível. Escolha outro.',
    },
    blockTitle: {
      papel: 'Papel da função',
      entregas: 'Entregas',
      detalhamento: 'Detalhamento de atividades',
      conhecimentos: 'Hard skills',
      formacao: 'Formação',
      treinamentos: 'Treinamentos',
      experiencia: 'Experiência',
      soft_skills: 'Soft skills',
    },
    activitiesHint: 'Ligue cada atividade à entrega que ela gera. Atividade sem entrega é transversal.',
    // s69 / 2o (V2): convite para pedir entregas quando ha atividades transversais
    transversalInvite: (n: number) =>
      n === 1
        ? '1 atividade do detalhamento está sem entrega. A VIGA pode sugerir uma entrega para ela; depois, ligue a atividade à entrega aceita.'
        : `${n} atividades do detalhamento estão sem entrega. A VIGA pode sugerir entregas para elas; depois, ligue cada atividade à entrega aceita.`,
    transversalSuggest: 'Sugerir entregas',
    singleItemHint: 'Este bloco aceita um único texto.',
    empty: 'Nenhum item ainda.',
    newItemLabel: (bloco: string) => `Novo item em ${bloco}`,
    add: 'Adicionar',
    requirementLabel: 'Exigência',
    necessario: 'Necessário',
    desejavel: 'Desejável',
    linkLabel: 'Entrega',
    transversal: 'Transversal (sem entrega)',
    edit: 'Editar',
    save: 'Salvar',
    cancel: 'Cancelar',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    remove: 'Excluir',
    hasActivities: (n: number) =>
      n === 1
        ? 'Esta entrega tem 1 atividade ligada. Desligue-a antes de excluir.'
        : `Esta entrega tem ${n} atividades ligadas. Desligue-as antes de excluir.`,
    publish: 'Publicar',
    publishTitle: (n: number) => `Publicar a versão ${n}?`,
    publishBody:
      'Depois de publicada, esta versão não pode mais ser alterada e passa a ser a descrição oficial do cargo. Para mudar depois, abre-se um rascunho novo.',
    publishConfirm: 'Publicar agora',
    // s62 / fatia s60c (A2): cabecalho escrito e nao salvo no momento de publicar
    headerUnsaved: 'O cabeçalho tem alterações que ainda não foram salvas. Elas serão salvas antes de publicar.',
    saveAndPublish: 'Salvar e publicar',
    // s59 fatia 2 (editor redesenhado; decisoes T3 nativo e T4 desfazer, 16/10/2026)
    moreActions: 'Mais ações',
    dragHandle: 'Arrastar para reordenar',
    clickToEdit: 'Clique para editar',
    editHint: 'Enter salva · Esc cancela',
    deleted: 'Item excluído.',
    // s69 / 2s: excluir item pede confirmacao (o Desfazer continua)
    confirmDeleteItem: (texto: string) => `Excluir o item "${texto.length > 80 ? texto.slice(0, 80) + '…' : texto}"?`,
    undo: 'Desfazer',
    undone: 'Item restaurado.',
    servesTo: (entrega: string) => `Serve a: ${entrega}`,
  },
  // s59 -- painel de IA ao lado do editor (referencia Attio, S31-7; G2 = A: a espera fica no painel).
  // s62 / C3b-2 (ADR-0032): faixas e funcoes da empresa
  bands: {
    back: 'Voltar para cargos',
    title: 'Faixas e funções',
    hint: 'Cada linha é uma faixa do organograma de cargos. Arraste uma função para outra faixa (os cargos com ela mudam de linha) ou arraste a alça da faixa para mudar a ordem. Também dá pelo menu da função e pelas setas.',
    hintReadOnly: 'Cada linha é uma faixa do organograma de cargos, com as funções que ficam nela.',
    noFunctions: 'Nenhuma função nesta faixa.',
    jobsCount: (n: number) => (n === 0 ? 'sem cargos' : n === 1 ? '1 cargo' : `${n} cargos`),
    functionActions: (f: string) => `Função ${f}: renomear, mover ou excluir`,
    rename: 'Renomear',
    moveTo: (b: string) => `Mover para ${b}`,
    deleteFunction: 'Excluir função',
    confirmDeleteFunction: (f: string) => `Excluir a função ${f}? Esta ação não pode ser desfeita.`,
    confirmDeleteBand: (b: string) => `Excluir a faixa ${b}? Esta ação não pode ser desfeita.`,
    renameFunction: (f: string) => `Novo nome da função ${f}`,
    renameBand: (b: string) => `Renomear a faixa ${b}`,
    dragBand: (b: string) => `Arrastar a faixa ${b}`,
    moveUp: (b: string) => `Subir a faixa ${b}`,
    moveDown: (b: string) => `Descer a faixa ${b}`,
    deleteBand: (b: string) => `Excluir a faixa ${b}`,
    newFunction: 'Nova função',
    addFunction: 'Incluir função',
    newBand: 'Nova faixa',
    addBand: 'Incluir faixa',
    bandCount: (n: number, max: number) => `${n} de ${max} faixas`,
    errors: {
      bandHasFunctions: (n: number) =>
        n === 1 ? 'Esta faixa tem 1 função. Mova-a para outra faixa antes de excluir.' : `Esta faixa tem ${n} funções. Mova-as para outra faixa antes de excluir.`,
      functionInUse: (n: number) =>
        n === 1 ? '1 cargo usa esta função. Troque a função dele antes de excluir.' : `${n} cargos usam esta função. Troque a função deles antes de excluir.`,
      nameExists: 'Já existe esse nome nesta empresa.',
      invalidName: 'O nome não pode ficar vazio nem passar de 80 letras.',
      bandLimit: 'A empresa já tem 12 faixas, o máximo.',
      lastBand: 'A empresa precisa de pelo menos 1 faixa.',
      generic: 'Não foi possível gravar. Tente de novo.',
    },
  },
  // s62 / PDF da descricao (modelo PES.001)
  descriptionPdf: {
    download: 'Baixar PDF',
    downloadDraft: 'Baixar PDF (rascunho)',
    downloading: 'Gerando o PDF...',
    error: 'Não foi possível gerar o PDF. Tente de novo.',
    formCode: (c: string) => `Formulário do PDF: ${c}`,
    formCodeLabel: 'Código do formulário do PDF',
    formCodeHint:
      'Código do seu sistema da qualidade (ex.: PES.001; a revisão entra como .Rev_01). Para escolher onde vai o número da revisão, escreva ## no lugar dele (ex.: FRH-012-REV##). Vazio volta ao padrão.',
    formCodeInvalid: 'Use só letras, números, ponto, hífen, sublinhado ou ## (até 32).',
    changeFormCode: 'Alterar',
    save: 'Salvar',
    cancel: 'Cancelar',
  },
  jobFunction: {
    none: 'Sem função',
    suggested: (f: string) => `Sugerida: ${f}`,
    choose: (cargo: string) => `Função do cargo ${cargo}`,
    useSuggestion: 'Usar sugestão',
    useSuggestionFor: (cargo: string, f: string) => `Usar a função sugerida ${f} para ${cargo}`,
    band: (b: string) => `Faixa: ${b}`,
    error: 'Não foi possível gravar.',
  },
  aiPanel: {
    suggest: 'Sugerir com a IA STRONGERH',
    title: (bloco: string) => `Sugestões para ${bloco}`,
    close: 'Fechar painel de sugestões',
    thinking: 'Pensando nas sugestões… pode levar alguns segundos. Você pode continuar editando.',
    retry: 'Tentar de novo',
    dataLink: 'Como a IA trata seus dados',
    accept: 'Aceitar',
    replace: 'Substituir o texto atual',
    edit: 'Editar antes de aceitar',
    acceptEdited: 'Aceitar com a edição',
    reject: 'Recusar',
    methodWarning: 'Atenção ao método:',
    // s59 fatia 2c (P7b): sem "peca outras" -- nao ha botao para isso ate a s60 (outras B, prompt 1.0.2).
    none: 'Nenhuma sugestão pendente.',
    redacted: (n: number) =>
      n === 1
        ? 'Antes de enviar o texto à IA, 1 dado pessoal foi trocado por um marcador.'
        : `Antes de enviar o texto à IA, ${n} dados pessoais foram trocados por marcadores.`,
    degraded: 'A IA não conseguiu responder agora. Tente de novo em instantes.',
    notEnabled: 'A IA ainda não está habilitada para a sua empresa.',
    userBudget: 'Você atingiu o limite mensal de uso da IA. Ele renova no início do próximo mês.',
    tenantBudget: 'A empresa atingiu o limite mensal de uso da IA. Ele renova no início do próximo mês.',
    disclaimer: 'Sugestões da IA. Você decide o que entra na descrição.',
    // s60 -- mascote VIGA (marca v1.5.0, Fabrica da Marca; texto aprovado por Marcelo em 17/10/2026, "um toque").
    // 18/10/2026 20:25, Marcelo: o nome sempre em MAIUSCULAS ("deixe viga escrita em maiuscula").
    vigaBadge: 'VIGA · IA STRONGERH',
    vigaIntro:
      'VIGA é a IA do STRONGERH ONE: com um toque, sugere papel, entregas, atividades e skills do cargo, e você decide o que fica.',
    // s60 "outras B": o prompt 1.0.2 le o que ja foi sugerido para o cargo e o bloco -- pedir de novo traz ideias novas.
    suggestMore: 'Sugerir outras',
  },
  // s59 -- pagina "Como a IA trata seus dados". Fatia 2c (decisao P8a/P8b de Marcelo, 17/10/2026 17:15): a TELA fica so
  // com protecao; provedor, pais e prazos (fatos conferidos em 16/10/2026 em privacy.claude.com: retencao de 30 dias,
  // ate 2 anos se sinalizado, sem treino com dados de clientes empresariais) vivem no CONTRATO e na Politica de
  // Privacidade (LGPD art. 9 e 33) -- nunca negados se perguntados (P8c). Mudou a politica do provedor -> mudar o contrato.
  // 17:28: "tira isso do rodape tambem" -- a tela nao menciona contrato nem Politica (decisao de Marcelo, risco aceito).
  // 17:36 (R2): caixa "Fechado para a sua empresa" -- so afirmacoes verdadeiras (R3 recusado; R4 = IA no proprio Azure, futuro).
  // s63 / ADR-0033 fatia 1 (nivel 1, sem IA). Frase do D10 -- so frases VERDADEIRAS.
  assistant: {
    title: 'Pergunte ao sistema',
    // s64 / 2e (V1, Marcelo 21/10/2026 20:54): com a IA LIGADA a tela vira "Pergunte à VIGA"; sem IA (V2) continua o sistema
    titleAi: 'Pergunte à VIGA',
    intro: 'Escolha o assunto e o cargo; a resposta vem do cadastro da sua empresa.',
    // s64 / fatia 2: a frase do D10 com IA -- so frases VERDADEIRAS (a IA recebe so o texto mascarado; a resposta e do banco).
    introAi:
      'As respostas vêm do cadastro da sua empresa e mostram de onde vieram. Quando a VIGA, a IA do STRONGERH, ajuda a entender a pergunta, ela recebe apenas o texto que você digitou, com nomes de pessoas, cargos e áreas, números e valores trocados por códigos. Os dados da sua empresa não são enviados.',
    textLabel: 'Escreva sua pergunta',
    textHelp: 'Não escreva dados pessoais na pergunta.',
    send: 'Perguntar à VIGA',
    // s64 / 2e (R2): proxima pergunta oferecida como botao (responde pelo cadastro, sem IA)
    nextLabel: 'Perguntar também:',
    // s64 / 2f (W1/W2): conversa de mensageiro
    // s67 / 2i (V2, Marcelo 25/10/2026): boas-vindas curtas, como num mensageiro
    welcome: 'Olá! Eu sou a VIGA, a IA do STRONGERH ONE! Em que posso ajudar?',
    thinking: 'VIGA está pensando…',
    today: 'Hoje',
    openMenus: 'Escolher pelo menu',
    closeMenus: 'Fechar os menus',
    aiBadge: 'Pergunta entendida pela IA STRONGERH',
    orMenus: 'Ou escolha nos menus:',
    // s64 / 2c (C3, C6)
    newChat: 'Nova conversa',
    you: 'Você',
    aiDataLink: 'Como a IA trata seus dados',
    topicLabel: 'Assunto',
    jobLabel: 'Cargo',
    choose: 'Escolha…',
    ask: 'Perguntar',
    source: 'Origem:',
    // s65 / 2g (G3 A): rodape da fala e o (i) que abre o detalhe
    sourceVia: 'via',
    sourceInfo: 'De onde veio esta resposta',
    openJob: 'Abrir a ficha do cargo',
    back: 'Voltar',
    // s70 / polegar (ADR-0036 L2): opcional, discreto; nada pede nem bloqueia a conversa
    rateUp: 'Resposta útil',
    rateDown: 'Não ajudou',
    rateMissingLabel: 'O que faltou? (opcional)',
    rateSend: 'Enviar',
    rateSkip: 'Pular',
    rateThanks: 'Obrigado pela avaliação.',
  },
  aiData: {
    title: 'Como a IA trata seus dados',
    back: 'Voltar',
    reviewed: 'Texto revisado em 18/10/2026.',
    sections: [
      // s64 / fatia 2 (D10): o assistente com IA tambem envia -- a frase anterior deixaria de ser verdadeira.
      {
        title: 'Quando',
        body:
          'Só quando alguém clica em "Sugerir com a IA STRONGERH" ou envia uma pergunta escrita em "Pergunte ao sistema". Nada é enviado sozinho.',
      },
      {
        title: 'O que a IA vê',
        // s60 (P-EMP + outras B): o texto anterior ficou incompleto -- a IA passou a receber tambem o perfil da empresa
        // (sem o nome) e o que ja foi sugerido. Texto final de Marcelo (T1, 18/10/2026 19:45), continua VERDADEIRO (R3).
        body:
          'Só o necessário para sugerir: o cargo que você está editando (nome, função, área, subordinação, os itens já escritos e as sugestões já feitas para ele) e o perfil da sua empresa. Na pergunta escrita, só o texto que você digitou, com nomes de pessoas, cargos e áreas, números e valores trocados por códigos — a resposta vem do cadastro, não da IA.',
      },
      {
        title: 'Protegido antes de sair',
        body:
          'Salário e faixa salarial nunca saem: o sistema bloqueia. CPF, CNPJ, e-mail, telefone, valores em R$, matrícula e nomes de pessoas são trocados por marcadores antes do envio.',
      },
      {
        title: 'Fechado para a sua empresa',
        body:
          'Os dados da sua empresa ficam isolados: nenhuma outra empresa cliente do STRONGERH tem acesso a eles. Não ficam abertos na internet, não são vendidos nem cedidos, e a conexão com a IA é criptografada. A IA não aprende com os seus dados.',
      },
      { title: 'Não treina', body: 'Seus dados não são usados para treinar a IA.' },
      { title: 'Você decide', body: 'Nada entra na descrição sem que você aceite.' },
      {
        title: 'Histórico só da sua empresa',
        body: 'Cada sugestão e cada pergunta ficam registradas (quem pediu, quando e o que foi decidido) para a sua auditoria interna; a pergunta fica com os nomes já trocados por códigos.',
      },
    ],
  },
  placeholder: {
    title: 'Em construção',
    message: 'Esta tela faz parte do Módulo 1 e está sendo construída.',
  },
  login: {
    title: 'Entrar',
    brandHeadline: 'Cargos, carreiras e pessoas, com método.',
    brandSubline:
      'A metodologia da Gente Consultoria em um só sistema, com IA e estatística para decisões de gestão de pessoas mais rápidas e precisas.',
    // Assinatura da GENTE no rodape do painel (S32-9): "uma solucao" acima do logo.
    brandSignature: 'uma solução',
    brandSignatureAlt: 'Gente Consultoria',
    subtitle: 'Acesse com seu e-mail corporativo e sua senha.',
    emailLabel: 'E-mail corporativo',
    passwordLabel: 'Senha',
    submit: 'Continuar',
    codeTitle: 'Verificação em duas etapas',
    codeHintEmail:
      'Enviamos um código de 8 dígitos para o seu e-mail corporativo. Ele vale por poucos minutos.',
    codeHintTotp: 'Digite o código de 6 dígitos do seu aplicativo autenticador.',
    codeRecoveryHint: 'Sem acesso ao código? Use um dos seus códigos de recuperação.',
    codeLabel: 'Código',
    codeSubmit: 'Entrar',
    back: 'Voltar',
    successTitle: 'Sessão iniciada',
    successMessage: 'Você entrou como',
    errors: {
      invalidCredentials: 'E-mail ou senha inválidos.',
      invalidCode:
        'Código inválido ou expirado. Para receber um novo código, volte e entre com a senha de novo.',
      mfaUnavailable:
        'A verificação em duas etapas está temporariamente indisponível. Tente de novo em instantes.',
    },
  },
  firstAccess: {
    passwordTitle: 'Crie a sua senha',
    passwordIntro:
      'A senha que você recebeu é provisória: foi criada por outra pessoa. Crie a sua para continuar.',
    newPasswordLabel: 'Nova senha',
    confirmPasswordLabel: 'Repita a nova senha',
    passwordRules:
      'De 12 a 128 caracteres, diferente do seu e-mail, do seu usuário e da senha provisória.',
    passwordMismatch: 'As duas senhas não são iguais.',
    passwordSubmit: 'Salvar senha',
    timeHint: 'Você tem 5 minutos para concluir cada etapa.',
    expired:
      'O tempo desta etapa acabou. Entre de novo — se você já criou a senha nova, use a senha nova.',
    errors: {
      too_short: 'A senha precisa ter pelo menos 12 caracteres.',
      too_long: 'A senha pode ter no máximo 128 caracteres.',
      equals_username: 'A senha não pode ser igual ao seu usuário.',
      equals_email: 'A senha não pode ser igual ao seu e-mail.',
      equals_current: 'A senha nova precisa ser diferente da senha provisória.',
      current_password_mismatch: 'A senha provisória não confere. Volte e entre de novo.',
      unknown: 'A senha não atende à política de segurança. Escolha outra.',
    },
    enrollTitle: 'Proteja a sua conta',
    enrollIntro:
      'Instale no celular um aplicativo autenticador (Microsoft Authenticator, Google Authenticator ou similar). Depois toque no botão abaixo e leia o QR code com o aplicativo.',
    enrollStart: 'Mostrar o QR code',
    qrLabel: 'QR code para o aplicativo autenticador',
    manualKeyLabel: 'Não consegue ler o QR code? Digite esta chave no aplicativo:',
    confirmCodeLabel: 'Código de 6 dígitos do aplicativo',
    confirmSubmit: 'Confirmar',
    invalidCode: 'Código inválido. Confira se o horário do celular está certo e tente o código seguinte.',
    codesTitle: 'Seus códigos de recuperação',
    codesIntro:
      'Guarde estes 10 códigos em lugar seguro. Cada um vale uma única vez, se você perder o celular. Eles NÃO serão mostrados de novo.',
    copy: 'Copiar',
    copied: 'Copiado',
    download: 'Baixar (.txt)',
    savedCheck: 'Guardei meus códigos em lugar seguro',
    codesContinue: 'Continuar',
    signinTitle: 'Último passo',
    signinIntro:
      'Espere o aplicativo mostrar um código NOVO (o anterior já foi usado) e digite-o para entrar.',
    signinSubmit: 'Entrar',
    emailVerifyTitle: 'Validação do e-mail',
    emailVerifyIntro:
      'Para proteger a sua conta, vamos enviar um código de 8 dígitos para o seu e-mail corporativo. Toque no botão abaixo e confira a sua caixa de entrada.',
    emailSend: 'Enviar código',
    emailSentInfo:
      'Enviamos o código para o seu e-mail. Ele vale por alguns minutos; se não chegar, confira a caixa de spam ou entre de novo para receber outro.',
    emailCodeLabel: 'Código de 8 dígitos do e-mail',
    emailConfirmSubmit: 'Validar e entrar',
    emailInvalidCode:
      'Código inválido ou vencido. Confira o último e-mail recebido; se o tempo acabou, entre de novo para receber outro código.',
    codesIntroEmail:
      'Guarde estes 10 códigos em lugar seguro. Cada um vale uma única vez, se um dia você ficar sem acesso ao seu e-mail. Eles NÃO serão mostrados de novo.',
    unsupportedStep:
      'Não foi possível continuar o primeiro acesso por aqui. Volte e entre de novo; se o problema continuar, fale com o administrador.',
  },
  common: {
    loading: 'Carregando…',
    retry: 'Tentar novamente',
    // s69 / 2s: toda exclusao pede confirmacao
    confirmDeleteTitle: 'Confirmar exclusão',
    confirmDeleteYes: 'Excluir',
    confirmDeleteNo: 'Cancelar',
  },
  error: {
    title: 'Não foi possível concluir a operação',
    genericMessage: 'Ocorreu um erro inesperado. Tente novamente em alguns instantes.',
    networkMessage: 'Não foi possível falar com o servidor. Verifique sua conexão.',
    requestIdHint: 'Ao relatar este erro, informe o código abaixo:',
  },
} as const

export type Translations = typeof ptBR
